import { StewardshipWrapper } from '@/features/stewardship/components/StewardshipWrapper';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

export default function Stewardship() {
  const [searchParams, setSearchParams] = useSearchParams();
  const plant_id = searchParams.get('plant_id');

  useEffect(() => {
    if (plant_id) return;
    setSearchParams((prev) => {
      prev.set('plant_id', '2');
      return prev;
    });
  }, [plant_id]);

  return (
    <div className="flex">
      <StewardshipWrapper />
    </div>
  );
}
